import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type {
  ExternalProviderRepository,
  InitializeContractBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface InitializeContractCommand {
  externalProviderRepository: ExternalProviderRepository;
  body: InitializeContractBody;
}

export const initializeContract = createAsyncThunk<string, InitializeContractCommand>(
  "externalProvider/initializeContract",
  async ({ externalProviderRepository, body }: InitializeContractCommand) => {
    return externalProviderRepository.initializeContract(body);
  },
);

export const resetInitializeContract = createAction("externalProvider/resetInitializeContract");
